import { useMutation, useQueryClient } from '@tanstack/react-query'
import { scheduleWorkItemUpdate } from 'api/admin/dayforce/scheduleWorkItemUpdate'
import { shiftDetailKey } from 'queries/shifts/keys'
import { dayforceKeys } from './keys'

export const useScheduleWorkItemUpdateMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      associationId,
    }: {
      associationId: number
      shiftId: number
    }) => scheduleWorkItemUpdate(associationId),
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: dayforceKeys.all,
      })
      await queryClient.invalidateQueries({
        queryKey: shiftDetailKey(variables.shiftId),
      })
    },
  })
}
